// extracted by mini-css-extract-plugin
module.exports = {"margin":"margin___1Au30","root":"root___2Df4R"};